


















import { ConfirmationMessageInterface } from '@/config/interfaces'
import Vue from 'vue'
import Check from '@/assets/Check.png'

export default Vue.extend({
  name: 'ConfirmationMessageEl',
  props: {
    templateItemData: {
      type: Object as () => ConfirmationMessageInterface,
      required: true
    }
  },
  data: () => ({
    check: Check
  })
})
